export default __webpack_public_path__ + "static/mattressscrims-145b69acc0343e22616f7628961dc056.jpg";